const companyInfo = {
  name: process.env.REACT_APP_COMPANY_NAME || 'Dial TPR',
  addressLines: [
    process.env.REACT_APP_COMPANY_ADDRESS_LINE1 || '21,Abu Complex, Madurai Main road',
    process.env.REACT_APP_COMPANY_ADDRESS_LINE2 || 'Tirupattur',
  ],
  phone: process.env.REACT_APP_COMPANY_PHONE || '9176687956',
  alterphone: process.env.REACT_APP_COMPANY_PHONE_ALTER || '9176126422',
  email: process.env.REACT_APP_COMPANY_EMAIL || 'dialtpr@gmail.com',
  gst: process.env.REACT_APP_COMPANY_GST || '',
};

export default companyInfo;
